import React from "react";

import { faClock, faSackDollar } from "@fortawesome/pro-regular-svg-icons";
import { FormattedMessage } from "react-intl";

import { BodyCopy4 } from "../../../../../vapor-components/typography";
import { ListCircleIcon, ListIcon } from "../../styled";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";

const CieCnsFeqChannel = () => {
    return (
        <>
            <ul className="fa-ul">
                <li>
                    <span className="fa-li">
                        <ListIcon icon={faClock} />
                    </span>
                    <BodyCopy4 color="yankeesBlue">
                        <FormattedMessage
                            id="c-new-spid-modal-content.recognition.cieCnsFeqChannels.complete-time"
                            values={{
                                b: chunks => <b>{chunks}</b>
                            }}
                        />
                    </BodyCopy4>
                </li>
                <li>
                    <span className="fa-li">
                        <ListIcon icon={faSackDollar} />
                    </span>
                    <BodyCopy4 color="yankeesBlue">
                        <FormattedMessage
                            id="c-new-spid-modal-content.recognition.cieCnsFeqChannels.cost"
                            values={{
                                b: chunks => <b>{chunks}</b>
                            }}
                        />
                    </BodyCopy4>
                </li>
            </ul>
            <BodyCopy4 color="yankeesBlue">
                <FormattedMessage id="c-new-spid-modal-content.recognition.cieCnsFeqChannels.required" />
            </BodyCopy4>
            <ul className="fa-ul">
                <li>
                    <span className="fa-li">
                        <ListCircleIcon icon={faCircle} />
                    </span>
                    <BodyCopy4 color="yankeesBlue">
                        <FormattedMessage
                            id="c-new-spid-modal-content.recognition.cieCnsFeqChannels.sign"
                            values={{
                                b: chunks => <b>{chunks}</b>
                            }}
                        />
                    </BodyCopy4>
                </li>
                <li>
                    <span className="fa-li">
                        <ListCircleIcon icon={faCircle} />
                    </span>
                    <BodyCopy4 color="yankeesBlue">
                        <FormattedMessage
                            id="c-new-spid-modal-content.recognition.cieCnsFeqChannels.identity-card"
                            values={{
                                b: chunks => <b>{chunks}</b>
                            }}
                        />
                    </BodyCopy4>
                </li>
            </ul>
        </>
    );
};

export default CieCnsFeqChannel;
